import { DateRange } from "./date";

export class ProductOffer {
    id: number;
    mlpId:number;
    appCode: string;
    createdDate: string;
    offerPrice:number;
}

export class ProductOfferSearch {
    createdDate: DateRange = DateRange.empty();
    id = '';
    mlpId=0;
    appCode = '';
    productName='';
    merchantId='';
    locationId='';
    status:''|number;
    offerPrice=0;
    linkedProduct:any;
 }